import React from 'react';
import {
  CreditCardOutlined,
  InfoCircleOutlined,
  LockOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';

import BrandHeader from '../../components/common/BrandHeader';
import KeyTerm from '../../components/common/KeyTerm';
import ResultHero from '../../components/common/ResultHero';
import { Card, CardBody, PageShell } from '../../components/common/Card';
import { ACTIVITY_TYPE } from '../../constants';
import { CONTACT_PHONE } from '../../constants/business';
import useQueryData from '../../hooks/useQueryData';
import { BrandName, HeroImage } from './styles';

const RESULT_TITLE = {
  [ACTIVITY_TYPE.CANCEL]: 'Your appointment has been cancelled',
  [ACTIVITY_TYPE.POSTPONE]: 'Your appointment has been postponed',
};

const Notification = () => {
  const { activityType } = useQueryData();
  const isBookingConfirmed = activityType === ACTIVITY_TYPE.CONFIRM;
  const resultTitle = RESULT_TITLE[activityType];

  return (
    <>
      <BrandHeader />
      <PageShell>
        <ResultHero
          tone="success"
          title={
            resultTitle || (
              <>
                Thank you for booking with <BrandName>Telecare</BrandName>
              </>
            )
          }
        />

        <HeroImage>
          <picture>
            <source
              srcSet={`${process.env.PUBLIC_URL}/assets/doctors-image.webp`}
              type="image/webp"
            />
            <img
              src={`${process.env.PUBLIC_URL}/assets/doctors-image.svg`}
              alt=""
            />
          </picture>
        </HeroImage>

        <Card>
          <CardBody>
            <KeyTerm icon={<InfoCircleOutlined />}>
              You will receive an email and SMS confirmation shortly.
            </KeyTerm>

            {isBookingConfirmed && (
              <>
                <KeyTerm icon={<CreditCardOutlined />}>
                  <b>That SMS includes your payment link.</b> Please complete
                  the payment to secure your appointment &mdash; no card details
                  are collected on this page.
                </KeyTerm>

                <KeyTerm icon={<InfoCircleOutlined />}>
                  <b>Your video link arrives by SMS and email.</b> Sent 3
                  business days and again 30 minutes before your appointment.
                </KeyTerm>

                <KeyTerm icon={<UnorderedListOutlined />}>
                  The Telecare team may contact you about supporting documents,
                  diagnostic reports or questionnaires needed for this
                  appointment.
                </KeyTerm>

                <KeyTerm icon={<InfoCircleOutlined />}>
                  We lodge your Medicare claim within <b>3 business days</b> of
                  you attending your appointment. Medicare pays any rebate
                  straight into your nominated bank account &mdash; the rebate
                  may vary based on your eligibility.
                </KeyTerm>
              </>
            )}

            <KeyTerm icon={<LockOutlined />}>
              If you are having problems please press the chat icon or call{' '}
              <b>{CONTACT_PHONE}</b> to speak with us.
            </KeyTerm>
          </CardBody>
        </Card>
      </PageShell>
    </>
  );
};

export default Notification;
